import { render, staticRenderFns } from "./KintaiCardList.vue?vue&type=template&id=58b5ecea&scoped=true&"
import script from "./KintaiCardList.vue?vue&type=script&lang=ts&"
export * from "./KintaiCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5ecea",
  null
  
)

export default component.exports